import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {VisionConfigService} from '../../services/vte/vision-config.service';
import {customerVisionModeLabel} from '../../services/vte/vision-customer-labels';

type OperationsNavItem = {
    path: string;
    label: string;
    exact: boolean;
};

@Component({
    selector: 'app-operations-shell',
    standalone: true,
    imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
    templateUrl: './operations-shell.component.html',
    styleUrl: './operations-shell.component.css',
})
export class OperationsShellComponent {
    readonly navItems: OperationsNavItem[] = [
        {path: '/operations', label: 'Operations Center', exact: true},
        {path: '/operations/transactions', label: 'Vehicle Transactions', exact: false},
        {path: '/operations/provider-events', label: 'Provider Events', exact: false},
    ];

    constructor(
        public visionConfig: VisionConfigService,
    ) {
    }

    visionModeLabel(mode: string): string {
        return customerVisionModeLabel(mode);
    }
}
